import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const Blogs = lazy(() => import('../../container/blogs'));
const View = lazy(() => import('../../container/blogs/View'));
const Add = lazy(() => import('../../container/blogs/Add'));
const Edit = lazy(() => import('../../container/blogs/Edit'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/blogs`} component={Blogs} />
      <Route exact path={`${path}/blogs/add`} component={Add} />
      <Route exact path={`${path}/blogs/view/:id`} component={View} />
      <Route exact path={`${path}/blogs/edit/:id`} component={Edit} />
    </Switch>
  );
}

export default PagesRoute;
